/* src/app/views/template/components/edit-template-menu-section/edit-template-menu-section.component.scss */
/*# sourceMappingURL=edit-template-menu-section.component.css.map */
